import { defineComponent, renderSlot, normalizeProps, guardReactiveProps, unref } from 'vue';
import { useMenuContext } from './use-menu-context.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "menu-context",
  setup(__props) {
    const menu = useMenuContext();
    return (_ctx, _cache) => {
      return renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps(unref(menu))));
    };
  }
});

export { _sfc_main as default };
